import { Link } from 'react-router-dom';

const tiers = [
  { range: '0–10单', rate: '10%', color: 'bg-blue-100 text-blue-700' },
  { range: '11–50单', rate: '20%', color: 'bg-indigo-100 text-indigo-700' },
  { range: '51–200单', rate: '28%', color: 'bg-purple-100 text-purple-700' },
  { range: '200单以上', rate: '35%', color: 'bg-green-100 text-green-700' },
];

export default function AffiliateSection() {
  return (
    <section className="py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-gradient-to-br from-blue-700 via-blue-600 to-indigo-600 overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left content */}
            <div className="flex-1 p-8 md:p-12">
              <p className="text-blue-200 text-sm font-semibold mb-2 uppercase tracking-wider">Affiliate Program</p>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
                推广赚钱<br />
                <span className="text-blue-200">轻松获得被动收入</span>
              </h2>
              <p className="text-blue-100 text-sm md:text-base mb-6 leading-relaxed">
                分享专属链接即可获得 <strong className="text-white">10%–35%</strong> 佣金，实时到账，永久有效，无上限。
              </p>

              {/* Commission tiers */}
              <div className="grid grid-cols-2 gap-2 mb-8">
                {tiers.map((t) => (
                  <div key={t.range} className="bg-white/10 rounded-xl p-3 flex items-center justify-between">
                    <span className="text-blue-100 text-xs">{t.range}</span>
                    <span className="text-white font-bold text-sm">{t.rate}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-3">
                <Link
                  to="/affiliate"
                  className="inline-flex items-center px-6 py-3 bg-white text-blue-700 font-bold rounded-xl hover:bg-blue-50 transition-colors cursor-pointer text-sm whitespace-nowrap"
                >
                  立即加入 →
                </Link>
                <Link
                  to="/help/referral"
                  className="inline-flex items-center px-6 py-3 border border-white/40 text-white font-medium rounded-xl hover:bg-white/10 transition-colors cursor-pointer text-sm whitespace-nowrap"
                >
                  了解更多
                </Link>
              </div>
            </div>

            {/* Right stats panel */}
            <div className="lg:w-72 bg-white/10 backdrop-blur-sm p-8 flex flex-col justify-center gap-6 border-t lg:border-t-0 lg:border-l border-white/10">
              {[
                { icon: 'ri-user-star-line', value: '8,200+', label: '活跃推广员' },
                { icon: 'ri-money-cny-circle-line', value: '320万+ U', label: '累计佣金发放' },
                { icon: 'ri-timer-flash-line', value: '实时', label: '佣金到账速度' },
                { icon: 'ri-infinity-line', value: '永久', label: '推广有效期' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-white text-xl`} />
                  </div>
                  <div>
                    <div className="text-white font-bold text-lg leading-tight">{item.value}</div>
                    <div className="text-blue-200 text-xs">{item.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
